<template>
  <div id="add-workstation">
    <!-- Content -->
    <div id="content">
      <!-- Main Content -->
      <div class="main-content" style="margin-top: -45px">
        <div class="row justify-content-center mb-2">
          <button class="btn btn-add" id="v-step-0" @click="startTour">
            Iniciar Tour de Reserva de Estação de Trabalho
          </button>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="card-title">Reservar Estação de Trabalho</div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4" id="v-step-1">
                    <label>Empresa</label>
                    <v-select :options="companies" label="company_name" :reduce="(companies) => companies"
                      class="style-chooser" v-model="filters.company"
                      v-on:input="getAvailableWorkstations(filters.company.id) && getWorkstationDetails(filters.company)">
                      <div slot="no-options">Nenhum registro encontrado.</div>
                    </v-select>
                  </div>
                  <!-- <div class="col-md-4">
                    <select class="form-control">
                      <option value="0">Selecione uma filial/prédio</option>
                    </select>
                  </div> -->
                  <div class="col-md-4" id="v-step-2" v-if="gotWorkstations">
                    <label>Estação de Trabalho</label>
                    <v-select :options="filters.company.workstations" label="title" :reduce="(filters) => filters.id"
                      class="style-chooser" v-model="filters.workstation">
                      <div slot="no-options">Nenhum registro encontrado.</div>
                    </v-select>
                  </div>
                  <div class="col-md-2" id="v-step-3">
                    <label for="date_start">Horário de Inicio</label>
                    <input type="time" v-model="filters.time_start" class="form-control" />
                  </div>
                  <div class="col-md-2" id="v-step-4">
                    <label for="date_start">Horário de Término</label>
                    <input type="time" v-model="filters.time_end" class="form-control" />
                  </div>

                  <!-- USAR ESSE CHECKBOX PARA DEIXAR OPCIONAL O FILTRO DE ADICIONAIS
                  <div class="col-md-2 mt-3">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch1"
                      />
                      <label
                        class="custom-control-label"
                        for="customSwitch1"
                      ></label>
                    </div>
                  </div> -->

                  <div class="col-md-12 mt-3" id="v-step-5" v-if="details.length > 0">
                    <div class="alert alert-dark" role="alert">
                      Abaixo você poderá filtrar as posições de acordo com seu
                      interesse, selecione os itens desejados e escolha um dia
                      no calendário.
                    </div>
                  </div>
                  <div class="col-md-12 mt-1">
                    <div class="row justify-content-center">
                      <div class="col-md centered lg-check" style="text-align: center" v-for="detail in details"
                        :key="detail.id">
                        <input type="checkbox" :value="detail.id" v-model="checkeds" :id="detail.id"
                          @change="clearSelecteds" />
                        <label :for="detail.id" class="pointer">{{
                          detail.title
                        }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 25px">
                  <div class="col-md-6">
                    <div class="accordion" id="workstation">
                      <div class="collapse show" id="agenda" data-parent="#workstation">
                        <div class="row mt-3 mb-2">
                          <div class="col-md-12">
                            <div class="card-title">Escolha os dias</div>
                          </div>
                        </div>
                        <div class="col-md-12" id="v-step-6">
                          <FullCalendar v-if="loadComponent" :options="calendarOptions" :config="config" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6" id="v-step-7">
                    <div class="row mt-3 mb-2">
                      <div class="col-md-12">
                        <div class="card-title">Dias Selecionados</div>
                      </div>
                      <div class="col-md-12 group-items" style="margin-top: 25px">
                        <ul class="list-group" v-for="date in selectedDates" :key="date.date" style="padding-bottom: 5px">
                          <li class="list-group-item" style="text-align: center">
                            {{ date.date_formated }}
                          </li>
                          <li class="list-group-item" style="text-align: center">
                            <div class="row">
                              <div class="col-md-12" style="margin-top: -15px; font-weight: bold">
                                {{ date.available.workstation.title }} -
                                <span style="
                                    font-weight: normal;
                                    font-style: italic;
                                  ">(
                                  {{ date.available.available.length }} posições
                                  disponíveis )</span>
                              </div>
                            </div>
                          </li>
                          <li class="list-group-item" style="text-align: center" v-if="date.place_id == null">
                            <button class="btn btn-main btn-block" @click="selectPlace(date)">
                              Selecionar Posição no Mapa
                            </button>
                          </li>
                          <li class="list-group-item" style="text-align: center" v-else>
                            <div class="row">
                              <div class="col-md-6">
                                <strong>Posição Selecionada:</strong>
                                {{ selectedPosition.title }}
                                <br />
                                <strong>Adicionais na Posição Selecionada:</strong>
                                {{ selectedPosition.details_text }}
                              </div>
                              <div class="col-md-6">
                                <button class="btn btn-main btn-block" @click="selectPlace(date)">
                                  Trocar Posição
                                </button>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <ul class="list-group" v-if="selectedDates.length == 0" style="padding-bottom: 5px">
                          <li class="list-group-item" style="text-align: center">
                            Nenhuma data selecionada.
                          </li>
                        </ul>
                      </div>
                      <div class="col-md-12">
                        <button class="btn btn-save btn-block" :disabled="isDisabled" @click="save">
                          Reservar Datas
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="loadedBlueprint">
      <div class="col-md-12">
        <div class="card-title">
          Escolha a posição para o dia
          {{ inSelection.date_formated }}
        </div>
      </div>
      <div class="col-md-12">
        <div class="card-body">
          <div class="top-container" style="border: 0px solid #f0f0f0; margin-top: -15px">
            <img :src="available.workstation.blueprint" v-on:load="onLoaded" class="image-size img-responsive"
              style="top: 0; left: 0" id="imagem-img" />
            <VueDragResize ref="draggable" v-for="(element, index) in elements" :key="index" :isActive="false"
              :w="available.workstation.wButton" :h="available.workstation.hButton" :x="parseFloat(element.left)"
              :y="parseFloat(element.top)" :minw="available.workstation.wButton" :minh="available.workstation.hButton"
              :parentLimitation="true" :isResizable="false" :isDraggable="false" class="text-center"
              @clicked="selectPosition(element)">
              <button v-if="available.select_chair == 1" class="btnD btn-primary" :style="'z-index: 1000 !important; width: ' +
                available.workstation.wButton +
                '; height: ' +
                available.workstation.hButton
                " data-toggle="tooltip" data-placement="top" :title="element.details_text">
                <i class="fas fa-chair" :style="'font-size: ' + fontSizeButton + 'px;'"></i>
              </button>
              <button v-else class="btnD btn-sm btn-primary" data-toggle="tooltip" data-placement="top" :style="'z-index: 1000 !important; width: ' +
                'auto' +
                '%; height: ' +
                available.workstation.hButton
                " :title="element.details_text">
                <span :style="'font-size: ' + fontSizeButton + 'px;'">{{
                  element.title
                }}</span>
              </button>
            </VueDragResize>
          </div>
        </div>
      </div>
    </div>
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step v-if="tour.currentStep === index" v-for="(step1, index) of tour.steps" :key="index" :step="step1"
            :previous-step="tour.previousStep" :next-step="tour.nextStep" :stop="tour.stop" :skip="tour.skip"
            :is-first="tour.isFirst" :is-last="tour.isLast" :labels="tour.labels">
            <template>
              <div slot="actions">
                <button v-if="tour.currentStep != 0" @click="tour.previousStep" class="btn-step-back">
                  Anterior
                </button>
                <button @click="cancelTour(tour.currentStep)" class="btn-step-back">
                  Pular tour
                </button>
                <button @click="
                  nextTour(
                    tour.currentStep,
                    tour.steps[index + 1],
                    tour.steps[index]
                  )
                  " v-if="tour.currentStep != 7" class="btn-step">
                  Próximo
                </button>
                <button @click="cancelTour(tour.currentStep)" v-else class="btn-step">
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import ptLocale from "@fullcalendar/core/locales/pt-br";
import interactionPlugin from "@fullcalendar/interaction";
import VueDragResize from "vue-drag-resize";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loaded: false,
      details: [],

      fontSizeButton: 10,
      checkeds: [],
      loadComponent: true,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        locale: ptLocale,
        selectable: true,
        unselectAuto: false,
        dateClick: this.selectDay,
      },
      config: {
        locale: "da",
      },

      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Reservas de Sala de Reunião!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content:
            "Aqui você seleciona a Empresa, para você poder escolher a Estação de Trabalho você precisa selecionar a Empresa.",
        },
        {
          target: "#v-step-2",
          params: {
            enableScrolling: false,
          },
          content: "Aqui você seleciona a Estação de Trabalho.",
        },
        {
          target: "#v-step-3",
          params: {
            enableScrolling: false,
          },
          content: "Aqui você seleciona o Horário de Ínicio da sua Reserva.",
        },
        {
          target: "#v-step-4",
          params: {
            enableScrolling: false,
          },
          content: "Aqui você seleciona o Horário de Término da sua Reserva.",
        },
        {
          target: "#v-step-5",
          params: {
            enableScrolling: false,
          },
          content:
            "Aqui você pode selecionar os itens desejados na posição e escolha um dia no calendário, caso não selecione nenhum item o sistema trará todas as posições disponiveis.",
        },
        {
          target: "#v-step-6",
          params: {
            enableScrolling: false,
          },
          content: "Aqui você seleciona o dia para a reserva.",
        },
        {
          target: "#v-step-7",
          params: {
            enableScrolling: false,
          },
          content:
            "Feito isso é só clicar em Selecionar Posição no Mapa, e irão aparecer todas as posições disponiveis conforme o seu filtro de busca, selecionando a posição é só clicar em Reservar Datas.",
        },
      ],

      selectedDates: [],
      selectedPosition: [],
      date_formated: "",
      last_info: "",
      today: {},
      companies: [],
      filters: {
        company: "",
        workstation: "",
        checkeds: [],
      },
      available: {},
      loadedBlueprint: false,

      width: 0,
      height: 0,
      top: 0,
      left: 0,
      selected: "",
      elements: [],
      card_height: 0,
      inSelection: {},
      gotWorkstations: false,
    };
  },
  components: { FullCalendar, VueDragResize, vSelect },
  computed: {
    isDisabled() {
      if (this.selectedDates.length <= 0) {
        return true;
      }
    },
  },
  methods: {
    save() {
      const self = this;
      const api = self.$store.state.api + "workstations/reserve";
      self.$http
        .post(api, self.selectedDates)
        .then((response) => {
          self.available = response.data;
          this.$router.push("/schedule_workstations");
          self.$message("Sucesso", "Datas reservadas com sucesso!", "success");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => { });
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 7) {
        if (step >= 7) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 7) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 7) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 7) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    selectPosition(object) {
      var foundIndex = this.selectedDates.findIndex(
        (element) => element.date == this.inSelection.date
      );
      this.selectedPosition = object;
      this.selectedDates[foundIndex].place_id = object.id;
      this.selectedDates[foundIndex].workstation_id = object.workstation_id;

      $(document).ready(function () {
        $("html, body").animate({ scrollTop: 0 }, 300);
      });

      setTimeout(() => {
        this.loadedBlueprint = false;
        this.inSelection = {};
      }, 400);
    },
    onLoaded() {
      const self = this;
      self.elements = self.sizeTreatment(self.available.available);
    },

    selectPlace(object) {
      const self = this;
      const api = self.$store.state.api + "workstations/available";

      self.inSelection = object;

      self.filters.date = object.date;
      self.filters.workstation = object.available.workstation.id;

      self.loadedBlueprint = false;

      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.available = response.data;
          self.workstation_details_text =
            response.data.workstation_details_text;
          self.loadedBlueprint = true;
          $(document).ready(function () {
            $("html, body").animate({ scrollTop: 750 }, 300);
          });
          setTimeout(function () {
            $(function () {
              $('[data-toggle="tooltip"]').tooltip();
            });
          }, 1000);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    selectDay(info) {
      if (info.dateStr < moment().format("YYYY-MM-DD")) {
        swal(
          "Ops!",
          "Você não pode selecionar uma data inferior à data atual",
          "error"
        );
      } else {
        var found = this.selectedDates.find(
          (element) => element.date == info.dateStr
        );

        var foundIndex = this.selectedDates.findIndex(
          (element) => element.date == info.dateStr
        );

        if (!found) {
          const self = this;
          const api = self.$store.state.api + "workstations/available";

          self.filters.date = info.dateStr;

          console.log(self.checkeds);
          self.filters.checkeds = self.checkeds;

          self.$http
            .post(api, self.filters)
            .then((response) => {
              var result = response.data;
              var obj = {
                date: info.dateStr,
                time_start: self.filters.time_start,
                time_end: self.filters.time_end,
                date_formated: moment(info.dateStr).format("LL"),
                info: info,
                available: result,
              };
              this.selectedDates.push(obj);
              info.dayEl.style.backgroundColor = "#4b2e8f";
            })
            .catch((error) => {
              self.$message(null, error.response.data, "error");
            });
        } else {
          this.selectedDates.splice(foundIndex, 1);
          found.info.dayEl.style.backgroundColor = "white";
        }
      }
    },
    clearSelecteds() {
      this.selectedDates.forEach((el) => {
        el.info.dayEl.style.backgroundColor = "white";
      });
      this.selectedDates = [];
    },
    getCompanies() {
      const self = this;
      const api =
        self.$store.state.api +
        "companies/?paginated=false&with[]=branches&with[]=workstations";
      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;

        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    resize: function (newRect, index) {
      this.elements[index].width = newRect.width;
      this.elements[index].height = newRect.height;
      this.elements[index].top = newRect.top;
      this.elements[index].left = newRect.left;
    },
    sizeTreatment: function (array) {
      const self = this;
      $.each(array, function (index, value) {
        array[index] = self.calculateDimensions(value);
      });
      return array;
    },
    calculateDimensions: function (obj) {
      let result = {};
      let imageSize = $("#imagem-img");
      let width = imageSize.width();
      let height = imageSize.height();
      this.card_height = height;

      result.active = false;
      result.top = (obj.top * height) / obj.screen_height;
      result.left = (obj.left * width) / obj.screen_width;
      result.screen_width = width;
      result.screen_height = height;
      result.width = (obj.width * width) / obj.screen_width;
      result.height = (obj.height * height) / obj.screen_height;
      result.workstation_id = obj.workstation_id;
      result.id = obj.id ? obj.id : null;
      result.title = obj.title ? obj.title : null;
      result.details_text = obj.details_text ? obj.details_text : null;

      return result;
    },
    getAvailableWorkstations(id) {
      const self = this;
      const api =
        self.$store.state.api +
        "workstations/groupAvailable"

      let fd = new FormData();

      fd.append("company_id", id);
      fd.append("user_id", self.$store.state.user.id);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.filters.company.workstations = response.data;
          console.log(response);
          self.gotWorkstations = true;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getWorkstationDetails: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "workstation_details/?paginated=false&company_id=" +
        id.id;

      self.$http
        .get(api)
        .then((response) => {
          self.details = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getCompanies();
  },
};
</script>

<style scoped>
.vdr {
  align-items: center;
  background: rgba(13, 80, 139, 0.4);
  /* border: 3px solid #0d508b; */
  border-radius: 20px;
}

.top-container {
  width: 100%;
  height: auto;
  position: relative;
}

.top-container img {
  width: 100%;
  height: auto;
  position: relative;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"]+label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #9a8cbc;
  background-color: #9a8cbc;
  color: #fff;
  border-radius: 0.25rem;
}

input[type="checkbox"]:checked+label {
  border: 2px solid #4b2e8f;
  color: #fff;
  background-color: #4b2e8f;
  font-style: normal;
}

.lg-check {
  min-width: 150px;
  max-width: 170px;
}

.btnD {
  border: 0px !important;
  border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/ScheduleWorkstations/Add.vue